export default "__VITE_ASSET__CDM$hrxm__"